import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button, Card, Icon } from '@/design-system';
import { Logo } from '@/components/Logo';
import { EmailOtpForm } from '@/components/EmailOtpForm';

export function LoginPage() {
  const { state } = useLocation() as { state: { from?: string } | null };
  const [params] = useSearchParams();
  const dest = state?.from && !state.from.startsWith('/login') ? state.from : undefined;
  const isFriendInvite = params.get('ref') === 'friend-invite';
  const returnTo = dest ?? (isFriendInvite ? '/friends' : '/cellar');
  const oidcHref = `/api/v1/auth/oidc/start?returnTo=${encodeURIComponent(returnTo)}`;
  const authError = params.get('error') != null;
  const authErrorMessage = params.get('message');

  return (
    <div className="relative grid min-h-screen items-start justify-items-center px-4 pt-8 sm:place-items-center sm:pt-0">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 left-1/3 h-96 w-96 rounded-full bg-candle/15 blur-3xl animate-flicker" />
        <div className="absolute right-0 bottom-0 h-[28rem] w-[28rem] rounded-full bg-ruby/15 blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative w-full max-w-md"
      >
        <Card glow className="grid gap-5 p-5 sm:gap-6 sm:p-8">
          <div className="flex flex-col items-center gap-2 text-center sm:gap-3">
            <Logo size={36} showWordmark={false} />
            <h1 className="font-serif text-2xl text-parchment sm:text-3xl">
              {isFriendInvite ? 'Du er invitert' : 'Velkommen tilbake'}
            </h1>
            <p className="text-xs text-mist sm:text-sm">
              {isFriendInvite
                ? 'Logg inn med Invested-kontoen din — vi binder vennskapet automatisk.'
                : 'Alkisen bruker samme innlogging som Invested, men kjører som egen app.'}
            </p>
          </div>
          {authError && (
            <div className="rounded-md border border-danger/35 bg-danger/10 px-3 py-2 text-xs text-parchment">
              {authErrorMessage
                ? authErrorMessage
                : 'Invested-innlogging feilet. Prøv igjen, eller bruk e-postkode under.'}
            </div>
          )}
          <Button
            type="button"
            size="lg"
            iconLeft="login"
            fullWidth
            onClick={() => {
              window.location.assign(oidcHref);
            }}
          >
            Fortsett med Invested
          </Button>
          <div className="grid gap-3 border-t border-line pt-4">
            <p className="text-center text-[11px] uppercase tracking-widest text-mist">Alternativ innlogging</p>
            <EmailOtpForm variant="large" redirectTo={returnTo} />
          </div>
        </Card>

        <div className="mt-4 text-center text-xs text-mist sm:mt-6">
          <Link to="/" className="inline-flex items-center gap-1 hover:text-candle">
            <Icon name="chevron-left" size={12} /> Til forsiden
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
